import {TooltipState, TooltipProps} from './tooltip';
import {ValidationTooltip} from './validation-tooltip';

export class HoverTooltip extends ValidationTooltip {
	public override readonly state = new TooltipState();

	// tooltip has to appear due mouse hover
	public override get isInitiallyHidden() {
		return true;
	}

	public override showTooltip(hide: boolean = true) {
		super.showTooltip(hide);
		if (!hide) {
			if (!this.rootElement) {
				return;
			}
			const {x, y} = this.recalculatePosition();
			if (x !== this.state.x || y !== this.state.y) {
				this.setState({x: x, y: y});
			}
		}
	}
}